// extracted by mini-css-extract-plugin
export var RichText = "B_bp";
export var aniSpin = "B_d";
export var headingStyles = "B_br";
export var imageStyles = "B_bs";
export var listStyles = "B_bq";
export var tableStyles = "B_bt";